module.exports = __webpack_public_path__ + "static/media/irish_sea.85c96f51.png";